const state = {
  anuncio: false,
  perguntasRespostas: false,
  perfil: false,
  login: false,
  resetSenha: false,
  logout: false,
  cadastroImcompleto: false,
  edicaoInformacoes: false,
  cadastroAnuncio: false,
  adicionarBeneficios: false,
  anuncioVendido: false,
  cancelarAnuncio: false,
  alterarSenha: false,
}

const getters = {
  getAnuncio: state => state.anuncio,
  getPerguntasRespostas: state => state.perguntasRespostas,
  getPerfil: state => state.perfil,
  getLogin: state => state.login,
  getResetSenha: state => state.resetSenha,
  getLogout: state => state.logout,
  getCadastroImcompleto: state => state.cadastroImcompleto,
  getEdicaoInformacoes: state => state.edicaoInformacoes,
  getCadastroAnuncio: state => state.cadastroAnuncio,
  getAdicionarBeneficios: state => state.adicionarBeneficios,
  getAnuncioVendido: state => state.anuncioVendido,
  getCancelarAnuncio: state => state.cancelarAnuncio,
  getAlterarSenha: state => state.alterarSenha,
}

const mutations = {
  setAnuncio: (state, payload) => state.anuncio = payload,
  setPerguntasRespostas: (state, payload) => state.perguntasRespostas = payload,
  setPerfil: (state, payload) => state.perfil = payload,
  setLogin: (state, payload) => state.login = payload,
  setResetSenha: (state, payload) => state.resetSenha = payload,
  setLogout: (state, payload) => state.logout = payload,
  setCadastroImcompleto: (state, payload) => state.cadastroImcompleto = payload,
  setEdicaoInformacoes: (state, payload) => state.edicaoInformacoes = payload,
  setCadastroAnuncio: (state, payload) => state.cadastroAnuncio = payload,
  setAdicionarBeneficios: (state, payload) => state.adicionarBeneficios = payload,
  setAnuncioVendido: (state, payload) => state.anuncioVendido = payload,
  setCancelarAnuncio: (state, payload) => state.cancelarAnuncio = payload,
  setAlterarSenha: (state, payload) => state.alterarSenha = payload,
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}